import React from 'react';
import { X, UserPlus, Calendar, Clock, Zap } from 'lucide-react';

const SignupBreakdownModal = ({ isOpen, onClose, stats }) => {
    if (!isOpen) return null;

    const breakdownItems = [
        {
            label: "Today's Signups",
            value: stats?.today || 0,
            icon: Clock,
            color: 'text-blue-600',
            bgColor: 'bg-blue-50',
            description: 'Signups in the last 24 hours'
        },
        {
            label: 'New (Last 2 Days)',
            value: stats?.two_days || 0,
            icon: Zap,
            color: 'text-amber-600',
            bgColor: 'bg-amber-50',
            description: 'Signups in the last 48 hours',
            isNew: true,
        },
        {
            label: 'Weekly Signups',
            value: stats?.this_week || 0,
            icon: Calendar,
            color: 'text-purple-600',
            bgColor: 'bg-purple-50',
            description: 'Signups in the last 7 days'
        },
        {
            label: 'Monthly Signups',
            value: stats?.this_month || 0,
            icon: UserPlus,
            color: 'text-emerald-600',
            bgColor: 'bg-emerald-50',
            description: 'Signups in the last 30 days'
        }
    ];

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4 animate-in fade-in duration-200">
            <div className="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden transform transition-all animate-in zoom-in-95 duration-200">
                {/* Header */}
                <div className="bg-gray-50 px-6 py-4 border-b border-gray-200 flex items-center justify-between">
                    <div className="flex items-center gap-2">
                        <div className="p-2 bg-purple-100 text-purple-600 rounded-lg">
                            <UserPlus className="w-5 h-5" />
                        </div>
                        <h3 className="text-lg font-bold text-gray-900">Signup Breakdown</h3>
                    </div>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 p-1 hover:bg-gray-100 rounded-full transition-colors"
                    >
                        <X className="w-6 h-6" />
                    </button>
                </div>

                {/* Body */}
                <div className="p-6 space-y-4">
                    {breakdownItems.map((item, index) => (
                        <div
                            key={index}
                            className={`flex items-center justify-between p-4 rounded-xl border transition-all group ${
                                item.isNew
                                    ? 'border-amber-200 bg-amber-50/50 hover:border-amber-300'
                                    : 'border-gray-100 hover:border-gray-200 hover:bg-gray-50'
                            }`}
                        >
                            <div className="flex items-center gap-4">
                                <div className={`p-3 rounded-xl ${item.bgColor} ${item.color} group-hover:scale-110 transition-transform`}>
                                    <item.icon className="w-6 h-6" />
                                </div>
                                <div>
                                    <div className="flex items-center gap-2">
                                        <p className="text-sm font-semibold text-gray-900">{item.label}</p>
                                        {item.isNew && (
                                            <span className="flex items-center gap-1 px-2 py-0.5 bg-amber-100 text-amber-700 text-[10px] font-bold rounded-full uppercase tracking-wide">
                                                <span className="w-1.5 h-1.5 bg-amber-500 rounded-full animate-pulse inline-block" />
                                                New
                                            </span>
                                        )}
                                    </div>
                                    <p className="text-xs text-gray-500">{item.description}</p>
                                </div>
                            </div>
                            <div className={`text-2xl font-bold ${item.isNew ? 'text-amber-700' : 'text-gray-900'}`}>
                                {item.value.toLocaleString()}
                            </div>
                        </div>
                    ))}
                </div>

                {/* Footer */}
                <div className="bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-white border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SignupBreakdownModal;
